<!-- ******************************* -->
<!--            LOGIN FORM           -->
<!-- ******************************* -->
<div *ngIf="checkTokenValidity" class="parent">
  <div class="fullHeight">
    <div class="loginCard">

      <div *ngIf="!isMediumScreen" class="logoContainer">
        <!-- ******************************* -->
        <!--              LOGO               -->
        <!-- ******************************* -->
        <img *ngIf="!appService.isDarkTheme"
             alt="ketonlogo"
             class="loginLogo centeredElement"
             src="assets/KetonLogo.png"/>
        <img
          *ngIf="appService.isDarkTheme"
          alt="ketonlogo"
          class="loginLogo centeredElement"
          src="assets/KetonLogo_white.png"/>
      </div>
      <div [style.max-width.px]="(isMobile) ? 300 : 400" [style.min-width.px]="(isMobile) ? 250 : 335"
           class="loginFormContainer">

        <div class="loginForm">

          <div *ngIf="isMediumScreen" class="logoContainer">
            <!-- ******************************* -->
            <!--              LOGO               -->
            <!-- ******************************* -->
            <img alt="ketonlogo"
                 class="loginLogo centeredElement"
                 fetchpriority="high"
                 src="assets/KetonLogo.png"/>
          </div>

          <div class="unselectable" style="flex-direction: row">
            <h3>{{ "RESET_PASSWORD.TITLE" | translate }}</h3>
          </div>

          <dx-form #loginForm (onEditorEnterKey)="changePassword()" [colCount]="1" [formData]="resetPasswordReq"
                   [validationGroup]="formValidationGroup"
                   id="form" labelMode="outside"
                   style="width: 100%">
            <dxi-item [editorOptions]="usernameEditorOptions" dataField="username">
              <dxi-validation-rule
                message="{{'RESET_PASSWORD.USERNAME_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
                type="required">
              </dxi-validation-rule>
              <dxo-label [text]="'RESET_PASSWORD.USERNAME' | translate"></dxo-label>

            </dxi-item>

            <dxi-item [editorOptions]="newPasswordEditorOptions" dataField="newPassword"
                      editorType="dxTextBox">
              <dxi-validation-rule
                message="{{'RESET_PASSWORD.NEW_PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
                type="required">
              </dxi-validation-rule>
              <dxo-label [text]="'RESET_PASSWORD.NEW_PASSWORD' | translate"></dxo-label>

            </dxi-item>

            <dxi-item [editorOptions]="confirmPasswordEditorOptions" dataField="confirmPassword"
                      editorType="dxTextBox">
              <dxi-validation-rule
                message="{{'RESET_PASSWORD.CONFIRM_PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}"
                type="required">
              </dxi-validation-rule>
              <dxi-validation-rule [comparisonTarget]="newPasswordValue" comparisonType="==="
                                   message="{{'ERROR.PASSWORDS_MISMATCH' | translate }}"
                                   type="compare">
              </dxi-validation-rule>
              <dxo-label [text]="'RESET_PASSWORD.CONFIRM_PASSWORD' | translate"></dxo-label>

            </dxi-item>

          </dx-form>
          <div
            style="display: flex;
            flex-direction: row;
            gap: 20px;
            width: 100%;
            padding: 8px 0;
            justify-content: space-between">
            <dx-button (click)="changePassword()" [elementAttr]="primaryButtonAttributes" [height]="40"
                       [text]="'RESET_PASSWORD.RESET' | translate " [type]="'default'" [width]="'100%'"
                       style="flex: 1 1;"></dx-button>

          </div>
        </div>
      </div>


    </div>
  </div>

  <!-- ******************************* -->
  <!--      POWERED BY INDICATION      -->
  <!-- ******************************* -->
  <div class="centerFooter">
    <span><em>Powered by  </em></span>
    <a href="https://aiknow.io" rel="noopener" target="_blank" title="AIknow">
      AIknow
    </a>
  </div>

</div>
